module.exports = __webpack_public_path__ + "img/ali.2c7c62b0.png";